import { ICON_HEIGHT_16, ICON_HEIGHT_24 } from '../Icon'

export const CHECKBOX_SIZE = {
  medium: 'medium',
  small: 'small',
}

export const CHECKBOX_TYPE = {
  action: 'action',
  rounded: 'rounded',
  table: 'table',
  tableRow: 'tableRow',
}

export const QA_NAME_CHECKBOX_DEFAULT = 'checkbox'

export const CHECKBOX_ICON_SIZE = {
  [CHECKBOX_SIZE.medium]: ICON_HEIGHT_24,
  [CHECKBOX_SIZE.small]: ICON_HEIGHT_16,
}
